<section class="gost-workspace">
  @if (isHandset()) {
    <nav
      class="gost-submenu"
      role="tablist"
      aria-label="GOST サブメニュー"
      [class.gost-submenu--entered]="submenuEntered()"
    >
      @for (tab of tabs; track tab.path; let tabIndex = $index) {
        <a
          class="gost-submenu__item"
          [routerLink]="[tab.path]"
          [class.gost-submenu__item--active]="isTabActive(tab.path)"
          role="tab"
          [style.--tab-index]="tabIndex"
        >
          <mat-icon>{{ tab.icon }}</mat-icon>
          <span>{{ tab.label }}</span>
        </a>
      }
    </nav>
  }

  <div class="gost-workspace__content">
    <router-outlet />
  </div>
</section>
